export default function playVideo(element, data) {
    const video = element.querySelector(".video");

    element.addEventListener("click", function () {
        video.setAttribute("controls", true);
        video.play();
        element.classList.add("started");
    });
}
